import request from "../../../utils/wapRequest";

const url = process.env.VUE_APP_WAP_API;

export function loginCheckpoint(data) {
  return request({
    url: `${url}/login_checkpoint`,
    method: "post",
    data
  });
}

export function loginShop(data) {
  return request({
    url: `${url}/login_shop_VTB`,
    method: "post",
    // params: data,
    data
  });
}
